import React from 'react';
import history from 'app/routes/history';
import Button from 'app/components/general/Button';
import Truncate from 'react-truncate';

interface IClubRowProps {
  club: any;
  payments: any;
  deleteClub: any;
  selectClub: any;
  updateClub: any;
}

interface IClubRowState {
  hovered: boolean;
  editable: boolean;
}

export default class ClubRow extends React.Component<
  IClubRowProps,
  IClubRowState
> {
  static defaultProps = {
    club: {},
    payments: undefined,
    deleteClub: undefined,
    selectClub: undefined,
    updateClub: undefined,
  };

  state: IClubRowState = {
    hovered: false,
    editable: false,
  };

  handleMouseEnter = (): void => {
    this.setState({ hovered: true });
  };

  handleMouseLeave = (): void => {
    this.setState({ hovered: false });
  };

  toggleClick = (): void => {
    this.setState((previousState: IClubRowState) => ({
      hovered: !previousState.hovered,
    }));
  };

  toggleEdit = (clubId): void => {
    this.props.selectClub(this.props.club.id);
    history.push(`/clubs/${clubId}/edit`);
  };

  toggleCancel = (): void => {
    this.setState({ editable: false });
  };

  handleDelete = (e): void => {
    e.preventDefault();

    this.props.deleteClub({ id: this.props.club.id });
  };

  selectClub = (): void => {
    this.props.selectClub(this.props.club.id);
    history.push('/dashboard');
  };

  render(): React.ReactNode {
    let selectButton = null;
    let editButton = null;
    let deleteButton = null;
    // if (this.state.hovered) {
    selectButton = (
      <Button className="btn-thinner btn-2" onClick={this.selectClub}>
        Select
      </Button>
    );

    editButton = (
      <Button
        className="btn-thinner btn-2"
        onClick={(): void => this.toggleEdit(this.props.club.id)}
      >
        Edit
      </Button>
    );

    deleteButton = (
      <Button
        className="btn-thinner btn-thin-padding btn-2"
        onClick={this.handleDelete}
      >
        Delete
      </Button>
    );
    // }

    return (
      <div
        className="row content-row"
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        // onClick={this.selectClub}
      >
        <div className="col col-6" onClick={this.selectClub}>
          <Truncate>{this.props.club.name}</Truncate>
        </div>
        <div className="col col-6 btn-flex-group">
          <div className="btn-flex-container thin-margin">
            {/* {selectButton} */}
            {editButton}
            {deleteButton}
          </div>
        </div>
      </div>
    );
  }
}
